import 'babel-polyfill';
import createFocusTrap from 'focus-trap/index.js';
import { PinClickEvent, PinHoverEvent, CardHoverEvent, CardClickEvent } from './Events.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { Maps } from 'js/components/Maps/index.js';
import { SearchMap } from 'js/search/modules/Google.js';
import { isVisible } from 'ts/components/Maps/isVisible.ts';

export class AceMap extends SearchMap {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.AceMap";
    this.breakPoint = 992;
  }

  constructor(args) {
    super(args);
    this.pinHeight = 45;
    this.pinWidth = 34;
    // Center roughly on Canada
    this.latitude = 58.40000000;
    this.longitude = -96.80972222;

  }

  appendScript() {
    /*
      DO NOTHING: Since autocomplete is loaded elsewhere and loads the same API,
      let it load the script and execute the callback
    */
  }

  static providerCallback() {
    Array.from(this.instances).forEach((instance) => {
      let loadMap = () => {
        instance.map = instance.prepareMap();
        let prepareEvent = null;
        prepareEvent = new CustomEvent('map.prepared', {});
        instance.element.dispatchEvent(prepareEvent);
      }
      if (isVisible(instance.element)) {
        loadMap();
      } else {
        let loadListener = () => {
          if(isVisible(instance.element)) {
            if (!instance.element.classList.contains('js-map-ready')) {
              loadMap();
            }
            OptimizedResizeInstance.remove(loadListener);
          }
        }
        OptimizedResizeInstance.on(loadListener);
      }
    });

    let lastWindowSize = window.innerWidth;

    if (window.innerWidth < 992) {
      $('#js-map-wrapper').collapse('hide');
    } else {
      $('#js-map-wrapper').collapse('show')
    }

    OptimizedResizeInstance.on( () => {
      if (window.innerWidth < 992 && lastWindowSize > 992) {
        $('#js-map-wrapper').collapse('hide');
      } else if (window.innerWidth > 992 && lastWindowSize < 992) {
        $('#js-map-wrapper').collapse('show')
      }

      lastWindowSize = window.innerWidth;
    });
  }

  iconImage(loc, i, backgroundColor, textColor) {
    if (backgroundColor == null) { backgroundColor = '#085EB9'; }
    if (textColor == null) { textColor = 'white'; }
    let iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1, backgroundColor, textColor))}`;

    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(this.pinWidth,this.pinHeight)
    };
  }

  registerClickHandlers() {
    registerClickHandlers();
  }

  updateMap() {
    this.setMapBounds();
  }

  prepareMap() {
    const map = super.prepareMap();
    this.constructor.map = map;
    return map;
  }

  preparePin(i, loc, m) {
    let pin = super.preparePin(...arguments);
    pin.isDefault = true;

    if (!this.constructor.disablePinHover) {
      pin.addListener('mouseover', () => {
        this.hoverHandler(true, loc, pin, i, m);
      });
      pin.addListener('mouseout', () => {
        this.hoverHandler(false, loc, pin, i, m);
      })
    }

    let changeColor = (needsHighlight) => {
      let hasHighlight = !pin.isDefault;
      if (needsHighlight && !hasHighlight) {
        let icon = this.iconImage(loc, i, '#003B64', 'white');
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isDefault = false;
        pin.setZIndex(1);
      } else if (!needsHighlight && hasHighlight) {
        let icon = this.iconImage(loc, i);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isDefault = true;
        pin.setZIndex(0);
      }
      else {}
        //do nothing
    };

    let needsHighlight = (e, type) => {
      let basicNeeds = e.detail.yextId === `js-yl-${loc.id}`;
      if (type !== 'hover') {
        return basicNeeds;
      }
      return basicNeeds && e.detail.active;
    }

    document.addEventListener(CardClickEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event));
    });

    document.addEventListener(PinClickEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event));
    });
    document.addEventListener(PinHoverEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event, 'hover'));
    });

    return pin;
  }
}
AceMap.initClass();

let registerClickHandlers = function() {
  let results = document.getElementsByClassName('js-location-result');
  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.AceMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseover', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.AceMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), true));
    });
    result.addEventListener('mouseout', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.AceMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), false));
    });
  }

  document.addEventListener(PinClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (id == null) { return; }
    const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.AceMap.breakPoint}px)`);
    if (minWidthSearchMapBreakPointQuery.matches) {
      document.getElementById(id).classList.add('is-selected');
    }
    let toRemove = document.querySelectorAll(`.js-location-result.is-selected:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
      toChange.classList.remove('is-hovered');
    }

    const container = document.querySelector('.Locator-content');
    const isIE11 =!!window.MSInputMethodContext && !!document.documentMode;
    const stickyHeight = isIE11 ? 0 : document.querySelector('.Locator-searchWrapper').offsetHeight;

    const targetEl = document.getElementById(id);

    function isScrolledIntoView(elem) {
      const elBottom = $(elem).position().top + elem.offsetHeight;
      return (elBottom <= container.offsetHeight) && ($(elem).position().top >= stickyHeight);
    }

    if (!isScrolledIntoView(targetEl)) {
      $('.Locator-content').animate({
          scrollTop: container.scrollTop + $(targetEl).offset().top - document.querySelector('header').offsetHeight - stickyHeight,
      }, {duration: 600, queue: false});
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (!id) { return; }
    const targetEl = document.getElementById(id);
    let selector = `.js-location-result.is-selected`;
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
    }
    targetEl.classList.add('is-selected');
  });

  document.addEventListener(PinHoverEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    const targetEl = document.getElementById(id);
    if (e.detail.active) {
      targetEl.classList.add('is-hovered');
    }
    let selector = `.js-location-result.is-hovered`;
    if (e.detail.active) {
      selector += `:not(#${id})`;
    }
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-hovered');
    }
  });
};

export const MapSetup = () => {
  registerClickHandlers();
}
